var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Injectable } from '@angular/core';
import { AbstractRestService, arrayOf, RestSettings } from '@gh/core-data';
import { InvoicesMapper } from './invoices.mapper';
import * as i0 from "@angular/core";
import * as i1 from "@gh/core-data";
var SupplierInvoicesRestService = /** @class */ (function (_super) {
    __extends(SupplierInvoicesRestService, _super);
    function SupplierInvoicesRestService(settings) {
        var _this = _super.call(this, settings) || this;
        _this.settings = settings;
        return _this;
    }
    SupplierInvoicesRestService.prototype.getAll = function () {
        return this.createSlicedDataSourceGet("/invoices", arrayOf(InvoicesMapper));
    };
    SupplierInvoicesRestService.prototype.delete = function (id) {
        return this.httpDelete("/invoices/" + id, void 0, InvoicesMapper);
    };
    SupplierInvoicesRestService.ɵfac = function SupplierInvoicesRestService_Factory(t) { return new (t || SupplierInvoicesRestService)(i0.ɵɵinject(i1.RestSettings)); };
    SupplierInvoicesRestService.ɵprov = i0.ɵɵdefineInjectable({ token: SupplierInvoicesRestService, factory: SupplierInvoicesRestService.ɵfac });
    return SupplierInvoicesRestService;
}(AbstractRestService));
export { SupplierInvoicesRestService };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierInvoicesRestService, [{
        type: Injectable
    }], function () { return [{ type: i1.RestSettings }]; }, null); })();
